export default {
  auth: {
    login_title: 'Welcome!',
    login: 'Login',
    register_title: 'Create Account',
    register: 'Register',
    forgot_password: 'forgot password',
    no_account: 'don\'t have an account',
    forgot_password_desc: 'Enter your email address and we will send you password change instructions',
    reset_password: 'Create New Password',
  },
  header: {
    profile: 'Profile',
    logout: 'Logout'
  },
  form: {
    validation: {
      required: '{field} is required',
      email: '{field} should be a valid email',
      min_length: '{field} must be at least {length} characters.',
      max_length: '{field} maximal {length} characters.',
      min_value: '{field} must be lequal or larger than {label}.',
      digit: '{field} must {length} digit',
      password_confirmation: 'Password must be identical.',
      password_strength: 'Passwords must contain a combination of uppercase, lowercase letters, numbers and special characters.'
    },
    button: {
      submit: 'Submit',
      yes: 'Yes',
      no: 'No',
      cancel: 'Cancel',
      back: 'Back',
      save: 'Save'
    },
    placeholder: {
      enter_email: 'Enter Email',
      select_industry: 'Please select an industry',
      select_province: 'Please select a province',
      select_province_first: 'Please select a province first',
      select_city: 'Please select a city'
    },
    field: {
      new_password: 'New Password',
      confirm_password: 'Confirm Password',
      name: 'Name',
      phone: 'Phone',
      address: 'Address',
      industry: 'Industry',
      province: 'Province',
      city: 'City',
      postal_code: 'Postal Code',
      personal_contact: 'Personal Contact',
    }
  }
}